var exports = {
  "JC": "UserProfilePopout.module__role___SHpud0",
  "s$": "UserProfilePopout.module__roleRemoveIcon___SHpud0",
  "Bx": "UserProfilePopout.module__iconSmall___SHpud0",
  "bc": "UserProfilePopout.module__profileCustomStatus___SHpud0",
  "CQ": "UserProfilePopout.module__profileCustomStatusText___SHpud0",
  "ZB": "UserProfilePopout.module__profileDisplayName___SHpud0",
  "yn": "UserProfilePopout.module__profileDataWarning___SHpud0",
  "zF": "UserProfilePopout.module__profilePopoutCard___SHpud0",
  "wt": "UserProfilePopout.module__profileSidebarCard___SHpud0",
  "sn": "UserProfilePopout.module__sidebarMutuals___SHpud0",
  "Pe": "UserProfilePopout.module__sidebarMutualAvatars___SHpud0",
};

module.exports = exports;
